export default "__VITE_ASSET__d69313d7__"